/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
// React Spectrum Components
import { Heading, IllustratedMessage } from '@adobe/react-spectrum';

// import get from "lodash/get";
import { JsonFormsDispatch } from "@jsonforms/react";
import _ from 'lodash';

export const NoDataError =
  <div data-testid="noDataError">
    <IllustratedMessage>
      <Heading>
        No results found
      </Heading>
    </IllustratedMessage>
  </div>

export const getExpandableRowsComponent = (
  row: any,
  mainPageContext: any,
  expandableRowsComponent: any,
  renderers: any,
  cells: any,
  config: any,
) =>
    <JsonFormsDispatch
      renderers={renderers}
      cells={cells}
      {...expandableRowsComponent}
      config={{ ...config, ...expandableRowsComponent.config, data: mainPageContext, rowData: row }}
    />

export const removeStyleAttributes = () => {
  const rdtTableCol = document.querySelectorAll('.rdt_TableCol');
  if (rdtTableCol && rdtTableCol.length > 0) {
    rdtTableCol.forEach((item) => {
      item.removeAttribute('style');
    });
  }
  const rdtTableCell = document.querySelectorAll('.rdt_TableCell');
  if (rdtTableCell && rdtTableCell.length > 0) {
    rdtTableCell.forEach((item) => {
      item.removeAttribute('style');
    });
  }
}

/**
 * based on the current page and pagesize return the array of items
 * @param {Object} result
 * @param {number} currentPage
 * @param {number} pageSize
 * @returns array of result
 */
export const getPerPageItems = (result:any, currentPage: number, pageSize: number): any[]=> {
  const table = [...result];
  const index = (currentPage * pageSize) - pageSize;
  if (index > 0) {
    const firsArr = _.drop(table, index);
    const lastArr = _.dropRight(firsArr, firsArr.length - pageSize);
    return lastArr;
  }
  const firstArr = table.splice(0, pageSize);
  return firstArr;
};

/**
 * calculates the total number of pages for the given `totalItems` and `limit`
 * @param {number} totalItems
 * @param {number} limit
 * @returns total pages
 */
export const calculateTotalPage = (totalItems:number, limit: number) => Math.ceil(totalItems / limit) || 1;